module.exports = __webpack_public_path__ + "static/media/Benjamin Grissom_1612007254486.b511fcdc.jpg";